import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';

import igConnectImage1 from "../../assets/images/ig-connect-1.png";
import igConnectImage2 from "../../assets/images/ig-connect-2.png";
const BENEFITS = [
    {
        image: igConnectImage1,
        title: 'More Brand Visibility'
    },
    {
        image: igConnectImage2,
        title: 'Curated Collabs'
    },
]

const IgConnectBenefits: React.FC = () => {
    return (
        <div className="position-relative w-100 ig-connect-benefit-slider">
            <Swiper
                slidesPerView={2}
                pagination={{ clickable: true }}
                loop={true}
                modules={[Pagination, Autoplay]}
                className="mySwiper w-100"
                spaceBetween={16}
            >
                {BENEFITS.map((slide, index) => (
                    <SwiperSlide key={index}>
                        <div className="ig-connect-benefit-slide">
                            <div
                                className="d-block rounded-4 w-100"
                                style={{
                                    backgroundImage: `url(${slide.image})`,
                                    position: 'relative',
                                    backgroundPosition: '50%',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'contain',
                                    paddingBottom: '57%'
                                }}
                            />
                            <span className='ig-connect-benefit-slide-title'>{slide.title}</span>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
}

export default IgConnectBenefits